export { default as ErrorRoute } from "./errorRoute";
